import script from "./ConfigContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigContent.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigContent.vue?vue&type=style&index=0&id=babd020a&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-babd020a"]])

export default __exports__